// Story 8.8 (AC2/AC5) — the completion screen's completed-cases table source
// (Screen 19). SELF-only read of the caller's SCORED submissions, ordered by case
// order; an empty list is a valid state (fresh clinician), never an error.

import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api-client";
import type { CalibrationSubmissionsData } from "@/hooks/queries/calibration-log-types";

export const CALIBRATION_SUBMISSIONS_QUERY_KEY = "calibration-submissions";

export function useCalibrationSubmissions(opts?: { enabled?: boolean }) {
  return useQuery({
    queryKey: [CALIBRATION_SUBMISSIONS_QUERY_KEY],
    queryFn: () => apiFetch<CalibrationSubmissionsData>("/calibration/submissions"),
    enabled: opts?.enabled ?? true,
    retry: false,
  });
}
